// @ts-nocheck

import { createAction, createSlice } from '@reduxjs/toolkit';
import { roleApi } from './../lib/api';
import { defaultPageSize } from './constants';
import type { Role } from '../lib/types';
export const SET_ROLES = '/vehicles/roles/set';
type RolesState = {
  data: Role[];
  page: number;
  pageSize: number;
  totalCount: number;
};

const initialState: RolesState = {
  data: [],
  page: 1,
  pageSize: defaultPageSize,
  totalCount: 0
};
const setRolesAction = createAction<Partial<RolesState>>(SET_ROLES);
const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setRolesAction, (state, {
      payload
    }) => ({
      ...state,
      ...payload
    }));
  }
});
export const rolesActions = {
  set: setRolesAction
};

// Подгрузка данных
export const fetchRoles = (page = 1, params = {}) => async (dispatch, getState) => {
  const {
    pageSize
  } = getState().roles;
  let {
    data,
    totalCount
  } = await roleApi.fetchRoles({
    page,
    pageSize,
    ...params
  });
  dispatch(rolesActions.set({
    data,
    totalCount,
    page,
    pageSize
  }));
};
export default rolesSlice.reducer;
